export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de productores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of producers"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop Fields"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop Fields"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspections"])}
        }
      }
    }
  })
}